<!--app-common-header
  [isAdminOrTutor]="role === '1' || role === '2'"
></app-common-header-->
<!-- <div style="background-color: red">abcdeed</div> -->

<div class="body body__secondary"  >
  <div class="mainContent">
    <div class="student-material" *ngIf="!dataLoading">
      <div class="student-material__top" [ngClass]="{ 'no-header': roleId === 4 }">
        <div class="student-material__top__left">
          <img
            src="assets/collapse-4-box.svg"
            class="cp"
            (click)="toggleOverlay(overlayPannel, $event)"
          />
          <span>{{ selectedLabel }}</span>
        </div>
        <div class="student-material__top__middle">
          <span
            [ngClass]="{
              'student-material__top__middle__btn--active': !viewAll,
              'student-material__top__middle__btn--inactive': viewAll
            }"
            (click)="viewAll ? toggleView(false) : false"
            >Recent</span
          >
          <span
            [ngClass]="{
              'student-material__top__middle__btn--active': viewAll,
              'student-material__top__middle__btn--inactive': !viewAll
            }"
            (click)="!viewAll ? toggleView(true) : false"
            >All</span
          >
        </div>
        <div class="student-material__top__right">
          <mat-icon
            class="student-material__filterSection__searchSection__searchBlock--icon"
            >search
          </mat-icon>
          <input
            class="student-material__filterSection__searchSection__searchBlock--input"
            [(ngModel)]="searchFilter"
            placeholder="Type to Search.."
          />
        </div>
      </div>
      <div class="student-material__body__heading">
        <div class="student-material__heading">
          <p-dialog
            [(visible)]="documentDialog"
            class="student-material__document"
            [maximizable]="true"
          >
            <div style="overflow-y: auto !important">
              <div
                class="d-flex justify-content-between mt-3 student-material__document--container"
                *ngIf="options?.accessType !== 3"
              >
                <!-- <button
                    class="button student-material__document--download"
                    (click)="printTest()"
                  >
                    Print
                  </button>  -->
                <button
                  (click)="downloadPdf(this.fileUrl, options.file_name)"
                  class="button student-material__document--download"
                >
                  Download
                </button>
              </div>
              <!-- PDF viewer addition -->
              <div *ngIf="viewURL">
                <pdf-viewer
                  class="notPdfList d-flex justify-content-center mt-3"
                  *ngIf="fileUrlExtension === 'pdf'"
                  [src]="viewURL!.href"
                  id="pdfViewerId"
                  [render-text]="false"
                  [original-size]="true"
                  [show-all]="true"
                >
                </pdf-viewer>
              </div>
              <!-- PDF viewer addition -->
            </div>
          </p-dialog>
        </div>

        <div
          class="student-material__filterSection"
          [ngClass]="{ 'student-material__filterSection--alternate': viewAll }"
        >
          <div *ngIf="files.length === 0">
            You do not have any new materials assigned. Click on All Materials
            Tab to see all files.
          </div>
        </div>
        <div
          *ngIf="!viewAll && selectedLabel !== '' && files.length > 0"
          class="student-material__recentFiles"
        >
          <div
            class="student-material__recentFiles__header student-material__recentFiles__row"
          >
            <div>File Name</div>
            <div>Category</div>
            <div class="text-center">Uploaded On</div>
            <div class="text-center">Due Date</div>
            <div>File Path</div>
          </div>
          <ng-container *ngFor="let file of fileNames">
            <div
              *ngIf="
                file.object_key.indexOf(selectedLabel) === 0 &&
                file.object_key
                  .toLowerCase()
                  .includes(searchFilter.toLowerCase())
              "
              class="student-material__recentFiles__row"
            >
              <div
                class="student-material__recentFiles__row--fileName pointer"
                (click)="displayDocumentDialog(file.file_id, file.file_name)"
              >
                {{ file.file_name }}
              </div>

              <div class="student-material__recentFiles__row__category">
                <mat-icon [ngStyle]="{ color: file.categoryColor || 'black' }"
                  >stop</mat-icon
                >
                {{ file.categoryName }}
              </div>
              <div
                class="text-center student-material__recentFiles__row--hidden-mobile"
              >
                {{ file.assignedOn }}
              </div>
              <div class="text-center">
                <span class="student-material__recentFiles__row--hidden-system"
                  >Due By: </span
                >{{ file.dueBy }}
              </div>
              <div class="student-material__recentFiles__row--hidden-mobile">
                {{ file.object_key.replace("/" + file.file_name, "") }}
              </div>
            </div>
          </ng-container>
        </div>
        <p-treeTable
          *ngIf="viewAll && selectedLabel"
          [value]="selectedCourse"
          class="student-material__allFiles"
        >
          <ng-template pTemplate="header">
            <tr class="student-material__allFiles__header">
              <th width="57%">Name</th>
              <th width="15%">Category</th>
              <th width="15%" class="text-center">Assigned Date</th>
              <th width="12%" class="text-center">Due By</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowNode>
            <tr
              *ngIf="
                rowNode.node.children ||
                (rowNode.node.label
                  .toLowerCase()
                  .includes(searchFilter.toLowerCase()) &&
                  (selectedCategories.length === 0 ||
                    selectedCategories.indexOf(rowNode.node.category) >= 0))
              "
            >
              <td>
                <div
                  class="d-flex align-items-center pointer"
                  (click)="
                    rowNode.node.children
                      ? false
                      : displayDocumentDialog(
                          rowNode.node.fileId,
                          rowNode.node.label
                        )
                  "
                >
                  <p-treeTableToggler
                    class="d-flex"
                    [rowNode]="rowNode"
                  ></p-treeTableToggler>
                  <mat-icon
                    class="student-material__allFiles__icon"
                    [ngClass]="{
                      'student-material__allFiles__icon--folder':
                        rowNode.node.children,
                      'student-material__allFiles__icon--file':
                        !rowNode.node.children
                    }"
                  >
                    {{
                      rowNode.node.children ? "folder" : "description"
                    }}</mat-icon
                  >
                  {{ rowNode.node.label }}
                </div>
              </td>
              <ng-container *ngIf="!rowNode.node.children">
                <td>
                  <div class="d-flex align-items-center">
                    <mat-icon
                      [ngStyle]="{
                        color: rowNode.node.categoryColor || 'black'
                      }"
                      >stop
                    </mat-icon>
                    {{ rowNode.node.categoryName }}
                  </div>
                </td>
                <td class="text-center">{{ rowNode.node.assignedOn }}</td>
                <td class="text-center">{{ rowNode.node.dueBy }}</td>
              </ng-container>
              <ng-container *ngIf="rowNode.node.children">
                <td></td>
                <td></td>
                <td></td>
              </ng-container>
            </tr>
          </ng-template>
        </p-treeTable>
      </div>
    </div>
    <p-dialog
      [(visible)]="showLoader || dataLoading"
      [modal]="true"
      [blockScroll]="true"
      [closeOnEscape]="true"
      [closable]="true"
      [showHeader]="false"
      appendTo="body"
      contentStyleClass="loader"
      styleClass="loaderContainer"
    >
      <!-- <mat-spinner>Please wait</mat-spinner> -->
      <p-progressSpinner strokeWidth="4"></p-progressSpinner>
    </p-dialog>
  </div>
</div>
<p-overlayPanel #overlayPannel>
  <div class="student-material__courses">
    <!-- <div *ngIf="files.length > 0" class="student-material__courses"> -->
    <div *ngFor="let file of files">
      <div
        class="student-material__courses__course"
        [ngClass]="{
          'student-material__courses__course--active':
            file.label === selectedLabel
        }"
        (click)="setLabel(file.label)"
      >
        {{ file.label }}
      </div>
    </div>
  </div>
</p-overlayPanel>
